import { render, staticRenderFns } from "./OperationsDashboard.vue?vue&type=template&id=22be744f"
import script from "./OperationsDashboard.vue?vue&type=script&lang=ts"
export * from "./OperationsDashboard.vue?vue&type=script&lang=ts"
import style0 from "./OperationsDashboard.vue?vue&type=style&index=0&id=22be744f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports